.ad{overflow:hidden;}